/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
import { css } from "lit";
const styles = css`.header{margin:0;display:flex;align-content:space-between;align-items:center;fill:var(--calcite-color-text-2);color:var(--calcite-color-text-2)}.heading{margin:0;padding:0;font-weight:var(--calcite-font-weight-medium)}.header .heading{flex:1 1 auto;padding:.5rem}`;
export {
  styles as s
};
